import { ReportData } from "../domain/types";

export const mockReport: ReportData = {
  creator_username:              "nika.style",
  creator_name:                  "Ника Стильная",
  creator_profile_picture_url:   "https://i.pravatar.cc/120?img=5",
  creator_followers_count:       124000,
  creator_media_count:           214,
  creator_biography:             "Лайфстайл и бьюти. Утренние ритуалы, уходовые обзоры и сборы в путешествие — всё по-настоящему.",
  creator_website:               "nikastyle.ru",
  catalog_message:               "Рассказываю о красоте и стиле честно — без фильтров и рекламных штампов. Аудитория — женщины 25–44, доход средний и выше, высокая вовлечённость.",
  limit:                         50,
  generated_at:                  "2026-06-09T10:00:00Z",
  period_start:                  "2026-01-01T00:00:00Z",
  period_end:                    "2026-06-01T00:00:00Z",
  summary: {
    total_reels:          47,
    reels_with_plays:     42,
    total_plays:       19364000,
    total_likes:         892400,
    total_comments:       45200,
    total_saves:         134800,
    total_shares:         67300,
    avg_plays_per_reel:  412000,
    er:           8.40,
    err:         12.70,
    like_rate:    6.20,
    comment_rate: 0.36,
  },
  audience: {
    countries: {
      "Россия":     87200,
      "Казахстан":  12400,
      "Беларусь":    8900,
      "Украина":     5600,
      "Германия":    3200,
      "США":         2800,
      "Турция":      1900,
      "Израиль":     1400,
      "ОАЭ":         1100,
      "Узбекистан":   900,
    },
    cities: {
      "Москва":              34800,
      "Санкт-Петербург":     18600,
      "Алматы":               9200,
      "Екатеринбург":         7400,
      "Новосибирск":          5200,
      "Краснодар":            4800,
      "Казань":               4200,
      "Минск":                3900,
      "Нижний Новгород":      3400,
      "Самара":               2800,
    },
    gender_age: {
      "F.13-17":  2.1,
      "M.13-17":  0.8,
      "F.18-24": 18.4,
      "M.18-24":  4.2,
      "F.25-34": 32.6,
      "M.25-34":  7.8,
      "F.35-44": 21.3,
      "M.35-44":  5.4,
      "F.45-54":  8.2,
      "M.45-54":  2.6,
      "F.55+":    3.4,
      "M.55+":    1.2,
    },
  },
  metrics: [
    {
      id: "p1",
      permalink: "https://www.instagram.com/p/demo1/",
      media_type: "VIDEO",
      timestamp: "2026-06-03T10:00:00Z",
      caption: "Утренний ритуал, который изменил мою кожу за 30 дней. Делюсь честно — без рекламы.",
      cover_url: "https://picsum.photos/seed/reel1/120/150",
      likes: 28400,
      comments: 1240,
      saves: 8900,
      plays: 412000,
      reach: 318000,
      avg_watch_time_ms: 18000,
      total_watch_time_ms: 7414000000,
      duration_ms: 42000,
      skip_rate: 0.11,
      follows_from_reel: 1840,
      skus: ["FW-2301", "SK-118"],
      brand_mentions: ["Clinique", "Sephora"],
      is_commercial: true,
    },
    {
      id: "p2",
      permalink: "https://www.instagram.com/p/demo2/",
      media_type: "VIDEO",
      timestamp: "2026-05-28T10:00:00Z",
      caption: "Собираю чемодан в Барселону. Что беру с собой в жаркий климат из косметики?",
      cover_url: "https://picsum.photos/seed/reel2/120/150",
      likes: 19200,
      comments: 842,
      saves: 6400,
      plays: 267000,
      reach: 201000,
      avg_watch_time_ms: 22000,
      total_watch_time_ms: 5874000000,
      duration_ms: 58000,
      skip_rate: 0.08,
      follows_from_reel: 920,
    },
    {
      id: "p3",
      permalink: "https://www.instagram.com/p/demo3/",
      media_type: "IMAGE",
      timestamp: "2026-05-22T10:00:00Z",
      caption: "Мой любимый уголок в квартире. Здесь я записываю все ролики.",
      cover_url: "https://picsum.photos/seed/photo1/120/150",
      likes: 14800,
      comments: 512,
      saves: 1900,
    },
    {
      id: "p4",
      permalink: "https://www.instagram.com/p/demo4/",
      media_type: "CAROUSEL_ALBUM",
      timestamp: "2026-05-15T10:00:00Z",
      caption: "10 вещей, которые я убрала из косметички навсегда. Листай →",
      cover_url: "https://picsum.photos/seed/carousel1/120/150",
      likes: 22600,
      comments: 1100,
      saves: 12400,
    },
    {
      id: "p5",
      permalink: "https://www.instagram.com/p/demo5/",
      media_type: "VIDEO",
      timestamp: "2026-05-09T10:00:00Z",
      caption: "Спа-день дома: всё что нужно — в твоей кухне. Маска из трёх ингредиентов.",
      cover_url: "https://picsum.photos/seed/reel3/120/150",
      likes: 31200,
      comments: 1560,
      saves: 9800,
      plays: 489000,
      reach: 374000,
      avg_watch_time_ms: 28000,
      total_watch_time_ms: 13692000000,
      duration_ms: 55000,
      skip_rate: 0.06,
      follows_from_reel: 2280,
      brand_mentions: ["Dove", "Nivea"],
      is_commercial: true,
    },
    {
      id: "p6",
      permalink: "https://www.instagram.com/p/demo6/",
      media_type: "VIDEO",
      timestamp: "2026-05-02T10:00:00Z",
      caption: "Честный обзор: пользуюсь этим кремом уже 3 месяца. Результат удивил.",
      cover_url: "https://picsum.photos/seed/reel4/120/150",
      likes: 24700,
      comments: 980,
      saves: 7300,
      plays: 358000,
      reach: 271000,
      avg_watch_time_ms: 20000,
      total_watch_time_ms: 7160000000,
      duration_ms: 48000,
      skip_rate: 0.14,
      follows_from_reel: 1120,
    },
    {
      id: "p7",
      permalink: "https://www.instagram.com/p/demo7/",
      media_type: "CAROUSEL_ALBUM",
      timestamp: "2026-04-24T10:00:00Z",
      caption: "Мои must-have на весну 2026. Вещи, которые ношу каждый день.",
      cover_url: "https://picsum.photos/seed/carousel2/120/150",
      likes: 18900,
      comments: 730,
      saves: 9100,
    },
    {
      id: "p8",
      permalink: "https://www.instagram.com/p/demo8/",
      media_type: "IMAGE",
      timestamp: "2026-04-17T10:00:00Z",
      caption: "Весеннее настроение 🌸",
      cover_url: "https://picsum.photos/seed/photo2/120/150",
      likes: 11200,
      comments: 340,
      saves: 820,
    },
  ],
};
